import { loc } from "../../../../packages/@okta/courage-dist/esm/src/CourageForSigninWidget.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/framework/Model.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/vendor/lib/backbone.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js";
import oktaUnderscore from "../../../../packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js";
import "../../../../packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/models/Model.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/models/BaseModel.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/framework/View.js";
import "../../../../packages/@okta/courage-dist/esm/src/courage/views/Backbone.ListView.js";
import fn from "../../../util/FactorUtil.js";
import FormType from "../../util/FormType.js";
import Util from "../../../util/Util.js";
import TextBox from "../shared/TextBox.js";
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
const form = {
  title: function() {
    const factorName = fn.getFactorLabel(this.model.get("__provider__"), this.model.get("__factorType__"));
    return loc("enroll.totp.title", "login", [factorName]);
  },
  subtitle: oktaUnderscore.partial(loc, "enroll.totp.enterCode", "login"),
  autoSave: true,
  noButtonBar: true,
  attributes: {
    "data-se": "step-sendcode"
  },
  formChildren: function() {
    return [FormType.Input({
      label: loc("mfa.challenge.enterCode.placeholder", "login"),
      "label-top": true,
      explain: Util.createInputExplain("mfa.challenge.enterCode.tooltip", "mfa.challenge.enterCode.placeholder", "login"),
      "explain-top": true,
      name: "passCode",
      input: TextBox,
      type: "tel"
    }), FormType.Toolbar({
      noCancelButton: true,
      save: loc("oform.verify", "login")
      // TODO: deprecated by mfa.challenge.verify
    })];
  }
};
export { form as default };
